<template>
	<div class="column" v-if="info">
		<div class="columnLeft">
			<img :src="info.picture" alt="" />
		</div>
		<div class="columnRight">
			<h1>{{info.title}}</h1>
			<p>{{info.brief}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			info:{
				required:false,
				type:Object
			}
		}
	}
</script>

<style scoped>
	.column {
		overflow: hidden;
		background: #fff;
		border-radius: 3px;
		padding: 20px;
		margin-bottom: 20px;
	}

	.columnLeft {
		float: left;
		width: 20%;
		height: 100px;
	}

	.columnLeft img {
		width: 100%;
		height: 100%;
	}


	.columnRight {
		float: left;
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.columnRight h1 {
		font-size: 22px;
		font-weight: bold;
		margin-bottom: 15px;
	}
	.columnRight p{
		color: #666;
	}
</style>
